import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { composeValidators, emailFormatValid, required } from '../../../../util/validators';
import { FieldTextInput, NamedLink } from '../../../../components';

/**
 * Contact form rendered inside the Console block `form-container`.
 * Fields match the Contact frame: name pair, work email, message, and a send button.
 */
const ContactForm = () => {
  const intl = useIntl();
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = () => {
    setSubmitted(true);
  };

  return (
    <FinalForm
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form className="contactForm" onSubmit={handleSubmit}>
          <div className="contactFormNames">
            <FieldTextInput
              className="contactFormField"
              id="contact-first-name"
              name="firstName"
              label={intl.formatMessage({ id: 'ContactForm.firstName' })}
              placeholder={intl.formatMessage({ id: 'ContactForm.firstNamePlaceholder' })}
              inputRootClass="contactFormInput"
              labelClassName="contactFormLabel"
              validate={required(intl.formatMessage({ id: 'ContactForm.firstNameRequired' }))}
            />
            <FieldTextInput
              className="contactFormField"
              id="contact-last-name"
              name="lastName"
              label={intl.formatMessage({ id: 'ContactForm.lastName' })}
              placeholder={intl.formatMessage({ id: 'ContactForm.lastNamePlaceholder' })}
              inputRootClass="contactFormInput"
              labelClassName="contactFormLabel"
              validate={required(intl.formatMessage({ id: 'ContactForm.lastNameRequired' }))}
            />
          </div>
          <FieldTextInput
            className="contactFormField"
            id="contact-email"
            name="email"
            type="email"
            label={intl.formatMessage({ id: 'ContactForm.workEmail' })}
            placeholder={intl.formatMessage({ id: 'ContactForm.emailPlaceholder' })}
            inputRootClass="contactFormInput"
            labelClassName="contactFormLabel"
            validate={composeValidators(
              required(intl.formatMessage({ id: 'ContactForm.emailRequired' })),
              emailFormatValid(intl.formatMessage({ id: 'ContactForm.emailInvalid' }))
            )}
          />
          <FieldTextInput
            className="contactFormField"
            id="contact-message"
            name="message"
            type="textarea"
            label={intl.formatMessage({ id: 'ContactForm.message' })}
            placeholder={intl.formatMessage({ id: 'ContactForm.messagePlaceholder' })}
            inputRootClass="contactFormInput"
            labelClassName="contactFormLabel"
            validate={required(intl.formatMessage({ id: 'ContactForm.messageRequired' }))}
          />
          <p className="contactFormNote">
            <FormattedMessage
              id="ContactForm.privacy"
              values={{
                privacyLink: (
                  <NamedLink name="PrivacyPolicyPage" className="contactFormPrivacy">
                    <FormattedMessage id="ContactForm.privacyLink" />
                  </NamedLink>
                ),
              }}
            />
          </p>
          <button className="contactFormSubmit" type="submit">
            <FormattedMessage id="ContactForm.submit" />
            <span className="contactFormArrow" aria-hidden="true" />
          </button>
          {submitted ? (
            <p className="contactFormThanks">
              <FormattedMessage id="ContactForm.thanks" />
            </p>
          ) : null}
        </form>
      )}
    />
  );
};

export default ContactForm;
